<mat-drawer-container class="side-panel-container" [hasBackdrop]="hasBackdrop">
  <mat-drawer [mode]="mode" [position]="position">
    <button class="close-panel-button"
            mat-icon-button
            (click)="toggleDrawer()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="side-panel-content">
      <ng-content select="[drawer]"></ng-content>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <ng-content select="[drawerContent]"></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
